import { transparentize, getLuminance } from 'polished';
import { token } from '@atlaskit/tokens';

/**
 * This will prefer light over dark - only the brightest of colors will get dark text.
 */

export const readableTextColor = (color: string): string => {
    return getLuminance(color) > 0.5 ? token('color.text', '#172B4D') : token('color.text.inverse', '#FFFFFF');
};

export const lightenColor = (color: string) => {
    return transparentize(0.8, color);
};
